export default __webpack_public_path__ + "static/media/SupportBugReport.1e6fa33a.svg";